import messages from '../../../locale/messages';

const validate = values => {
    const errors = {};

    if (!values.riderPhoneNumber || isNaN(values.riderPhoneNumber) || values.riderPhoneNumber.trim() === "") {
        errors.riderPhoneNumber = messages.required;
    }

    if (!values.riderEmail || !values.riderEmail.toString().match(/^(([^<>()[\]\\.,;.!#$&%*+/=?:{|}~\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i)) {
        errors.riderEmail = messages.required;
    } else if (!/^[A-Z0-9.%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.riderEmail)) {
        errors.riderEmail = messages.emailInvalid;
    }

    if (!values.riderFirstName || values.riderFirstName.toString().trim() === "") {
        errors.riderFirstName = messages.required;
    } else if (values.riderFirstName && (values.riderFirstName.length < 3 || values.riderFirstName.length > 20)) {
        errors.riderFirstName = messages.firstnameValidate;
    }

    if (!values.riderLastName || values.riderLastName.toString().trim() === "") {
        errors.riderLastName = messages.required;
    } else if (values.riderLastName && (values.riderLastName.length < 3 || values.riderLastName.length > 20)) {
        errors.riderLastName = messages.lastnameValidate;
    }
    if (values.locations) {
        let errorLocations = [];
        values.locations.map((item, index) => {
            let previousLocation = index > 0 && values.locations[index - 1].data && { ...values.locations[index - 1].data.location, label: values.locations[index - 1].data.value };
            if (!item.data || !item.data.location || !item.data.location.latitude || !item.data.location.longitude)
                errorLocations[index] = { data: messages.required };
            else if (previousLocation && ((previousLocation.latitude === item.data.location.latitude && previousLocation.longitude === item.data.location.longitude) || previousLocation.value === item.data.value)) {
                errorLocations[index] = { data: messages.samePlaceValidate };
            }
        });
        if (errorLocations.length > 0) errors.locations = errorLocations;
    }

    if (values.bookingType === 2 && (!values.scheduleFrom || isNaN((new Date(values.scheduleFrom)).getTime()))) {
        errors.scheduleFrom = messages.required;
    }

    return errors;
};

export default validate;